import { v4 as uuidv4 } from 'uuid';
import { unsubscribeAPI } from './api';
import refreshProfileCollections from './refreshProfileCollections';

export function expandSubscriptions(subscriptionId) {
    this.subscriptionsExpanded[subscriptionId] = true;
    this.observed.subscriptionsExpanded = uuidv4();
}

export function closeSubscriptions(subscriptionId) {
    this.subscriptionsExpanded[subscriptionId] = false;
    this.observed.subscriptionsExpanded = uuidv4();
}

export async function unsubscribe(subscription) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    // Saved for rollback — addInInactiveSubscriptions clears this id's
    // connected/available schedules (and loaded flag), so a failed call
    // needs to restore them.
    const previousConnectedSchedules = this.connectedSchedules[subscription.id];
    const previousAvailableSchedules = this.availableSchedules[subscription.id];
    const previousAvailableSchedulesLoaded = this.availableSchedulesLoaded[subscription.id];

    // Optimistic: remove from active and move to inactive immediately
    this.deleteInActiveSubscriptions({ subscription });
    this.addInInactiveSubscriptions({ subscription });
    refreshProfileCollections(this.subscriptions);

    // Guards the upcoming delayed refetch against the backend's own sync
    // tech not having caught up yet — see the field's comment in index.js.
    this.pendingUnsubscribeIds.add(subscription.id);

    this.env.startLoadCounter({ target: 'loadingUnsubscribe' });

    const res = await unsubscribeAPI({ store: this, token: session.token, traceId, subscriptionId: subscription.id });

    this.env.stopLoadCounter();

    if (res?.error) {
        // Rollback: restore to active, remove from inactive
        this.inactiveSubscriptions = this.inactiveSubscriptions.filter((s) => s.id !== subscription.id);
        subscription.isActive = true;
        this.subscriptions = [subscription, ...this.subscriptions];
        this.connectedSchedules = { ...this.connectedSchedules, [subscription.id]: previousConnectedSchedules || [] };
        this.availableSchedules = { ...this.availableSchedules, [subscription.id]: previousAvailableSchedules || [] };
        this.availableSchedulesLoaded[subscription.id] = previousAvailableSchedulesLoaded;
        this.observed.subscriptions = uuidv4();
        this.observed.availableSchedules = uuidv4();
        refreshProfileCollections(this.subscriptions);
        this.pendingUnsubscribeIds.delete(subscription.id);
        return { success: false };
    }

    this.observed.unsubscribe = uuidv4();

    // Re-syncing from the server is the caller's job now, not this action's
    // — it needs to happen after the success dialog is dismissed, not
    // immediately here.
    return { success: true };
}

export function removeItemFromUnsubscribeList() {
    this.unsubscribeList.pop();
}
